import { inject, Injectable } from "@angular/core";
import { ChargingConfigurationService, ChargingSessionsService, ParkingPlaceService, ParkingSpotService } from "../../../core/chardi-proxy-api/services";
import { map, Observable } from "rxjs";
import { ChardiOverviewDto, ChargingConfiguration, UpdateDisplayNameRequest } from "../../../core/chardi-proxy-api/models";

@Injectable({
  providedIn: 'root',
})
export class ChardiService {
  private chardiConfigurationApiService = inject(ChargingConfigurationService);
  private chardiParkingPlaceApiService = inject(ParkingPlaceService);
  private chardiParkingStopApiService = inject(ParkingSpotService);
  private chardiChargingSessionsApiService = inject(ChargingSessionsService);

  getChargingConfiguration(chargerId: string, connectorId: number): Observable<ChargingConfiguration> {
    return this.chardiConfigurationApiService
      .apiChargingConfigurationGetByChargerIdAndConnectorIdChargerIdConnectorIdGet$Json$Response({ chargerId, connectorId })
      .pipe(
        map((res) => {
          if (res.ok) {
            return res.body;
          } else {
            throw Error();
          }
        })
      )
  }

  getParkingPlaceAndParkingSpots(chargerId: string, connectorId: number): Observable<ChardiOverviewDto> {
    return this.chardiParkingPlaceApiService
      .apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Json$Response({ chargerId, connectorId })
      .pipe(
        map((res) => {
          if (res.ok) {
            return res.body
          } else {
            throw Error();
          }
        })
      )
  }

  updateChargingConfiguration(chargingConfiguration: ChargingConfiguration): Observable<ChargingConfiguration> {
    return this.chardiConfigurationApiService
      .apiChargingConfigurationPut$Json$Response({ body: chargingConfiguration })
      .pipe(
        map((res) => {
          if (res.ok) {
            return res.body
          } else {
            throw Error();
          }
        })
      )
  }

  removeFromQueue(parkingPlaceId: number, moduleIds: number[]): Observable<void> {
    return this.chardiParkingStopApiService
      .apiParkingSpotCmsRemoveFromQueueParkingPlaceIdPost$Response({ parkingPlaceId: parkingPlaceId, body: moduleIds })
      .pipe(
        map((res) => {
          if (res.ok)
            return;
          else {
            throw Error();
          }
        })
      )
  }

  addToQueue(parkingPlaceId: number, moduleIds: number[]): Observable<void> {
    return this.chardiParkingStopApiService
      .apiParkingSpotCmsAddToQueueParkingPlaceIdPost$Response({ parkingPlaceId: parkingPlaceId, body: moduleIds })
      .pipe(
        map((res) => {
          if (res.ok)
            return;
          else {
            throw Error();
          }
        })
      )
  }

  stopTransaction(sessionId: number): Observable<void> {
    return this.chardiChargingSessionsApiService
      .apiChargingSessionsStopChargingSessionSessionIdPost$Response({ sessionId })
      .pipe(
        map((res) => {
          if(res.ok)
            return;
          else 
            throw Error();
        })
      )
  }

  requestQueueReorder(parkingPlaceId: number, moduleIds: number[]): Observable<void>{
    return this.chardiParkingStopApiService
      .apiParkingSpotCmsUpdateParkingSpotsOrderPositionParkingPlaceIdPost$Response({ parkingPlaceId: parkingPlaceId, body: moduleIds })
      .pipe(
        map((res) => {
          if (res.ok)
            return;
          else {
            throw Error();
          }
        })
      )
  }

  updateDisplayNames(request: UpdateDisplayNameRequest): Observable<void> {
    return this.chardiParkingStopApiService
      .apiParkingSpotCmsUpdateDisplayNamePut$Response({body: request})
      .pipe(
        map(
          (res) => {
            if (res.ok) {
              return;
            } else {
              throw Error("Failed to update display names");
            }
          }
        )
      )
  }
}